(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("AssetAvailabilityImport", AssetAvailabilityImport);

    AssetAvailabilityImport.$inject = ["AmcUpload","$state","$timeout"];
    function AssetAvailabilityImport(AmcUpload,$state,$timeout) {

        var vm = this;
		var formData,getFile;
		
          $(":file").filestyle({
            buttonBefore: true,
            buttonText: "Browse File",
        });
        
        vm.importxlsx = /^(.*?)\.(xlsx)$/;
		vm.upload = function () {

    var file = document.getElementById('uploadfile').files[0];
    var formData = new FormData();
    formData.append("file", file);

    AmcUpload.uploadAssetAvailability(formData).then(function (response) {

        var contentType = response.headers('content-type');

        // If backend returned file
        if (contentType === "application/octet-stream") {

            var blob = new Blob([response.data], { type: contentType });

            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = "NotProcessedRows.xlsx";
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
			$timeout(function () {
		        $state.go("asset");
		    }, 200);

        } else {
            // Convert buffer to text (Success message)
            var text = new TextDecoder("utf-8")
                .decode(new Uint8Array(response.data));
				$timeout(function () {
		          $state.go("asset");
		       }, 200);
            alert(text);
        }

    }, function (error) {
        console.log("Error:", error);
    });
};
    }
})();
